import React from 'react';
import LandPageTypes from '../LandPageTypes';
import KeyCodes from '../../utils/KeyCodes';
import '../../../resources/css/login.css';

class Login extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.LOGIN)
            return null;

        const login = this.props.login;
        const events = this.props.events;
        const username = login.username;
        const password = login.password;
        const executingLogin = login.executingLogin;
        const lastMenu = login.lastMenu;

        const onLogin = (e) => {
            e.preventDefault();
            events.onLogin(username, password, lastMenu);
        };

        const onUsernameChanged = (e) => events.onUpdateText('username', e.target.value);

        const onPasswordChanged = (e) => events.onUpdateText('password', e.target.value);

        const onUsernameKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ENTER && username && username.length > 0)
                return this.inputPassword.focus();

            if (e.keyCode === KeyCodes.ESCAPE)
                return events.onUpdateText('username', '');
        };

        const onPasswordKeyDown = (e) => {
            if (e.keyCode === KeyCodes.ENTER)
                return events.onLogin(username, password, lastMenu);

            if (e.keyCode === KeyCodes.ESCAPE)
                return events.onUpdateText('password', '');
        };

        const buttonEntrarText = executingLogin === true ? 'Processando...' : 'Entrar';

        const buttonEntrarDisabled = executingLogin === true;

        return (
            <div className="container">
                <form className="form-signin" onSubmit={() => {}}>
                    <h2 className="form-signin-heading">Entrar</h2>
                    <label className="sr-only">Email</label>
                    <input type="email" className="form-control" placeholder="Usuário"
                           required="required" autoFocus="autoFocus"
                           value={username} onChange={onUsernameChanged} onKeyDown={onUsernameKeyDown} />
                    <label className="sr-only">Senha</label>
                    <input type="password" className="form-control" placeholder="Senha" required="required"
                           ref={(input) => { this.inputPassword = input; }}
                           value={password} onChange={onPasswordChanged} onKeyDown={onPasswordKeyDown} />
                    <button className="btn btn-lg btn-primary btn-block"
                            type="button"
                            disabled={buttonEntrarDisabled}
                            onClick={onLogin}>
                        {buttonEntrarText}
                    </button>
                </form>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// src/views/landpages/Login.jsx